import { Badge } from '@/shared/components/ui/badge'
import { formatRelativeDateTime } from '@/shared/lib/DateUtil'
import type { ChatConversation, DeliveryState } from '@/entities/chat'
import { cn } from '@/shared/lib/utils'
import { CallsignRail } from './CallsignRail'
import { DeliveryTicks } from './DeliveryTicks'
import { PersonAvatar } from './PersonAvatar'
import { GroupAvatar } from './GroupAvatar'

export function ConversationRow({
  conversation,
  active,
  deliveryState,
  myUserId,
  onSelect,
}: {
  conversation: ChatConversation
  active: boolean
  deliveryState: DeliveryState | null
  myUserId: number | null
  onSelect: () => void
}) {
  const previewPrefix =
    conversation.lastMessageSenderUserId == null
      ? ''
      : conversation.lastMessageSenderUserId === myUserId
        ? 'You: '
        : conversation.lastSenderName
          ? `${conversation.lastSenderName}: `
          : ''
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'flex w-full items-start gap-2.5 border-b border-line-2 px-3 py-2.5 text-left transition-colors hover:bg-hover',
        active && 'bg-brand-accent-soft',
      )}
    >
      {conversation.type === 'Direct' ? (
        <PersonAvatar name={conversation.title} photoUrl={conversation.photoUrl} photoFileId={conversation.photoFileId} />
      ) : conversation.type === 'Group' ? (
        <GroupAvatar members={conversation.memberPreviews ?? []} callsign={conversation.callsign} />
      ) : (
        <CallsignRail callsign={conversation.callsign} />
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2">
          <span className="truncate text-[13px] font-semibold text-ink">{conversation.title}</span>
          <span className="ml-auto shrink-0 font-mono text-[11px] tabular-nums text-ink-4">
            {formatRelativeDateTime(conversation.lastMessageAt)}
          </span>
        </div>
        <div className="mt-0.5 flex items-center gap-1">
          {deliveryState && <DeliveryTicks state={deliveryState} />}
          <p className="min-w-0 flex-1 truncate text-[12.5px] text-ink-3">
            {previewPrefix}
            {conversation.lastMessagePreview ?? ''}
          </p>
          {conversation.hasUnread && (
            <Badge tone="info" className="ml-1 h-4 shrink-0 px-1.5 py-0 text-[10px] leading-none">
              New
            </Badge>
          )}
        </div>
      </div>
    </button>
  )
}
